import { FC } from 'react';
import { Typography, Box } from '@gemini/fe-ds-core';

interface GridHeaderProps {
  header: string;
}

const GridHeader: FC<GridHeaderProps> = ({ header }) => (
  <Box
    display={'flex'}
    flexDirection={'column'}
    justifyContent={'center'}
    padding={'10px 16px'}
  >
    <Typography variant="textMedium">{header}</Typography>
  </Box>
);

export default GridHeader;
